import { appThemeStyle } from "@/constants/theme.config";
import { Skeleton } from "antd-mobile";
import { logPageAccess } from "@/utils/logPageAccess";
import bus from "@/utils/mitt";
import { useCptUtil } from "./useCptUtil";
import { pxChangeVw } from "@/utils";
import { homeAtom } from "@/atoms/home";
import { headerAtom } from "@/atoms/app";
import slideDistance from "@/utils/slideDistance";
import { waitForElement } from "@/utils/waitForElement";
import { removeEmpty } from "@/utils/removeEmpty";

const Header: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const maskNode = useRef<any>(null);
  const animateRef = useRef<any>(null);
  const [isShowLocationIcon] = useState(true);
  const { pathname } = useLocation();
  const { isRtl } = useLanguage();
  const locInfo = LocalStorage.getItem("INFO");
  const headerData = useAtomValue(headerAtom);

  useEffect(() => {
    logPageAccess(pathname, isDevEnv);
    bus.emit("refreshAd");
  }, [pathname]);

  waitForElement(animateRef).then((el: any) => {
    if (!el) {
      return;
    }
    requestAnimationFrame(() => {
      slideDistance({
        end: el?.parentElement?.clientWidth - el?.clientWidth,
      })(animateRef.current);
    });
  });

  const updateChildState = () => {
    maskNode.current.setVisible(!maskNode.current.visible);
  };
  const homeData = useAtomValue(homeAtom);
  const weatherStatus = homeData?.data?.info?.weatherStatus || locInfo?.weatherStatus;
  const headerStyle = appThemeStyle?.[weatherStatus]?.headerStyle ?? {};
  const imgStyle = {
    height: pxChangeVw("25px"),
    marginTop: "12.5px",
  };

  if (isEmptyType(removeEmpty(headerData))) {
    return (
      <Skeleton
        animated
        style={{ "--width": "100%", "--height": pxChangeVw("50px") as string, "--border-radius": "0px" }}
        className="border-b-1 border-b-solid border-b-[var(--app-border-04)]"
      />
    );
  }
  const mergedHeaderStyle = { ...headerStyle };
  const { getCpt01 } = useCptUtil({
    mergedHeaderStyle,
    containerRef,
    isRtl,
    updateChildState,
    isShowLocationIcon,
    maskNode,
    animateRef,
    headerData,
    imgStyle,
  });
  return getCpt01();
};

export default Header;
